var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHr = function SvgIconHr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24 12c0-1.468-.264-2.874-.746-4.174L12 7.304.746 7.826A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174L12 16.695l11.254-.521c.482-1.3.746-2.706.746-4.174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 24c5.16 0 9.558-3.257 11.253-7.827H.746C2.442 20.743 6.84 24 12 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M.746 7.827h22.507C21.558 3.257 17.16 0 12 0 6.84 0 2.442 3.257.746 7.827"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#338AF3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.13 8.348h-2.086l.348-2.61 1.391-1.043 1.391 1.044v2.087zM8.87 8.348h2.087l-.348-2.609-1.392-1.043-1.39 1.043v2.087z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M13.391 8.348h-2.783V5.739L12 4.696l1.391 1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M7.826 7.826v5.739a4.17 4.17 0 0 0 1.678 3.344l.73-.183.923.927a4.2 4.2 0 0 0 1.682 0l1.052-.875.605.129a4.17 4.17 0 0 0 1.678-3.342v-5.74z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.496 7.826h-1.67v1.67h1.67zM12.835 7.826h-1.67v1.67h1.67zM16.174 7.826h-1.67v1.67h1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.165 9.495h-1.67v1.67h1.67zM14.505 9.495h-1.67v1.67h1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.496 11.164h-1.67v1.67h1.67zM11.165 12.835h-1.67v1.67h1.67zM12.835 11.164h-1.67v1.67h1.67zM16.174 11.164h-1.67v1.67h1.67zM14.505 12.835h-1.67v1.67h1.67zM12.835 14.504h-1.67v1.67h1.67zM9.495 14.504H7.934a4.16 4.16 0 0 0 .81 1.67h.751zM14.505 16.174h.75a4.16 4.16 0 0 0 .812-1.67h-1.562zM9.495 16.173v.729a4.16 4.16 0 0 0 1.67.753v-1.482zM12.835 16.173v1.482a4.16 4.16 0 0 0 1.67-.753v-.729z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconHr;